<div class="bina-proposal" [ngClass]="{ 'bina-proposal-selected': isFullHTS }">
  <div class="bina-proposal-header">
    <div class="bina-proposal-header-code">
      <div class="bina-proposal-header-code-items">
        <ng-content *ngTemplateOutlet="codeGroupItem; context: { groupNum: BINA_FIRST_GROUP_NUM }"></ng-content>

        <ng-content *ngTemplateOutlet="codeGroupItem; context: { groupNum: BINA_SECOND_GROUP_NUM }"></ng-content>

        <div class="bina-proposal-header-code-dot"></div>

        <ng-content *ngTemplateOutlet="codeGroupItem; context: { groupNum: BINA_THIRD_GROUP_NUM }"></ng-content>

        <div class="bina-proposal-header-code-dot"></div>

        <ng-content *ngTemplateOutlet="codeGroupItem; context: { groupNum: BINA_FOURTH_GROUP_NUM }"></ng-content>

        <ng-content *ngTemplateOutlet="codeGroupItem; context: { groupNum: BINA_FIFTH_GROUP_NUM }"></ng-content>

        <div
          class="bina-proposal-header-code-title"
          nz-tooltip
          nzTooltipPlacement="top"
          [nzTooltipTitle]="(isCopied ? 'COPIED' : 'COPY_TO_CLIPBOARD') | translate"
          [style.width]="titleLength"
          (click)="copyToClipboard()"
          (nzTooltipVisibleChange)="resetCopyText()"
        ></div>
      </div>
    </div>

    <div class="d-flex h-100">
      <!--Show path-->
      <div
        class="bina-proposal-header-action"
        nz-tooltip
        nzTooltipPlacement="top"
        [nzTooltipTitle]="'SHOW_PATH' | translate"
        (click)="subGroupClick.emit(htsCode)"
        *ngIf="isShowPath"
      >
        <div class="bina-proposal-header-action-button">
          <img src="assets/icons/icon_path.svg" />
        </div>
      </div>

      <!--Hts insert-->
      <div
        class="bina-proposal-header-action"
        nz-tooltip
        nzTooltipPlacement="top"
        [nzTooltipTitle]="'INSERT_TO_LINE_ITEM' | translate"
        (click)="htsInsert.emit()"
        *ngIf="isFullHTS && isShowInsertCode"
      >
        <div class="bina-proposal-header-action-button" *ngIf="isShowInsertCode">
          <img src="assets/icons/icon_insert_item.svg" />

          <div class="bina-proposal-header-action-text d-none d-md-block" *ngIf="isShowInsertCode && !isShowPath">
            {{ "INSERT_TO_LINE_ITEM" | translate }}
          </div>
        </div>
      </div>

      <!--Add to catalog-->
      <div
        class="bina-proposal-header-action"
        nz-tooltip
        nzTooltipPlacement="top"
        [nzTooltipTitle]="'ADD_TO_CATALOG' | translate"
        (click)="addHtsToCatalog.emit()"
        *ngIf="isFullHTS && isShowAddToCatalog"
      >
        <div class="bina-proposal-header-action-button" *ngIf="isShowAddToCatalog">
          <img src="assets/icons/icon_insert_catalog.svg" />
        </div>
      </div>
    </div>
  </div>

  <div class="bina-proposal-body">
    <p class="bina-proposal-body-header" *ngIf="!!firstText">{{ firstText }}</p>

    <span class="bina-proposal-body-header-secondary" *ngIf="!!secondText && formattedOptions?.length">{{ secondText }}</span>
    <div class="bina-proposal-body-items" *ngIf="formattedOptions?.length && !isFullHTS">
      <ng-container *ngFor="let option of formattedOptions">
        <div
          class="bina-proposal-body-item"
          [attr.data-hts]="option.hts"
          [ngClass]="{ 'bina-proposal-body-item-selected': isOptionSelected(option.hts) }"
          (click)="selectHTS(option.hts)"
          *ngIf="!!option.description"
        >
          {{ option.description }}
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #codeItemEmpty>
  <div class="bina-proposal-header-code-item">
    <div class="bina-proposal-header-code-item-empty-placeholder"></div>
    <div class="bina-proposal-header-code-item-empty-placeholder"></div>
  </div>
</ng-template>

<ng-template #codeGroupItem let-groupNum="groupNum">
  <div class="bina-proposal-header-code-item" *ngIf="!!codeGroupAt(groupNum); else codeItemEmpty">
    {{ codeGroupAt(groupNum) }}
  </div>
</ng-template>
